import Axios from 'api/client';
import { Relationship } from 'types/domain';
import { PaginatedData } from 'types/pagination';

interface ContactAssociation {
    type: string;
    contactId: number;
    relatedContactId: number;
}

interface FetchRelationshipsParams {
    page?: number;
    limit?: number;
}

interface UpdateRelationshipParams {
    type: string;
    related_type: string;
}

const fetchContactRelationships = (
    accountId: number,
    contactId: number,
    params = {} as FetchRelationshipsParams,
) => {
    return Axios.get<PaginatedData<Relationship>>(
        `/accounts/${accountId}/contacts/${contactId}/relationships`,
        {
            params,
        },
    ).then(response => response.data);
};

const fetchContactRelationshipById = (
    accountId: number,
    contactId: number,
    relationshipId: number,
) => {
    return Axios.get<Relationship>(
        `/accounts/${accountId}/contacts/${contactId}/relationships/${relationshipId}`,
    ).then(response => response.data);
};

const deleteContactRelationshipById = (
    accountId: number,
    contactId: number,
    relationshipId: number,
) => {
    return Axios.delete(
        `/accounts/${accountId}/contacts/${contactId}/relationships/${relationshipId}`,
    ).then(response => response.data);
};

const updateContactRelationshipById = (
    accountId: number,
    contactId: number,
    relationshipId: number,
    params: UpdateRelationshipParams,
) => {
    return Axios.patch(
        `/accounts/${accountId}/contacts/${contactId}/relationships/${relationshipId}`,
        params,
    ).then(response => response.data);
};

const createRelationships = (accountId: number, contactAssociations: ContactAssociation[]) => {
    const relationships = contactAssociations.map(association => ({
        contact_id: association.contactId,
        related_contact_id: association.relatedContactId,
        type: association.type,
    }));
    return Axios.post(`/accounts/${accountId}/relationships`, {
        relationships,
    });
};

export {
    fetchContactRelationshipById,
    deleteContactRelationshipById,
    updateContactRelationshipById,
    fetchContactRelationships,
    createRelationships,
};
export type { ContactAssociation };
